const autoNgTemplateLoaderTemplate1 = require('./endpoints.html');

import { EndpointsController } from './endpointsController';

angular.module('portainer.app').component('endpointsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: EndpointsController,
});
